import { useDispatch } from 'react-redux';
import { useSeriesNextEpisode } from '../../hooks/useSeriesNextEpisode';
import PlayVideoButton from './PlayVideoButton';
import { Button, FontIcon } from '@intigral/shared';
import { showUpgradedModal } from '../../store/reducers/generalConfigurationSlice';
import { ButtonTypes } from '../../config/constants';
import _ from 'lodash';
import { __ } from '../../translations';
import playerService from '../../helpers/bitmovinPlayer';

export const MoviePlayButton = ({
    componentType,
    componentName,
    meta,
    isTvod,
    isRented,
    item,
    tvodRentText,
    openDetailOverlay,
    hours,
    minutes,
    locked,
    isComingSoonItem,
}) => {
    const {
        title,
        nextEpisode,
        bookmarkData: { isBookmared },
    } = useSeriesNextEpisode(item);
    const dispatch = useDispatch();
    if (isComingSoonItem) {
        return null;
    }
    if (!item?.isLocked && locked) {
        return (
            <Button
                onClick={(e) => {
                    e.stopPropagation();
                    dispatch(showUpgradedModal(true));
                }}
                data-test-id="play-button"
            >
                {title || __('play_now')} <FontIcon name="lock" size="smaller" md="smaller" />
            </Button>
        );
    }
    if (isBookmared && item.programType === 'series') {
        return (
            <PlayVideoButton
                buttonType={ButtonTypes.VodeItem}
                item={nextEpisode || item}
                componentType={componentType}
                componentName={componentName}
                testId="resume-watching-button"
                isLoading={title ? false : true}
            >
                {title}
            </PlayVideoButton>
        );
    }

    if (!isTvod && !isBookmared && item.programType === 'series') {
        return (
            <PlayVideoButton
                buttonType={ButtonTypes.VodeItem}
                item={nextEpisode || item}
                componentType={componentType}
                componentName={componentName}
                testId="play-now-button"
                isLoading={title ? false : true}
            >
                {title}
            </PlayVideoButton>
        );
    }

    if (!isTvod || (isTvod && ((isRented && hours > 0) || minutes > 0))) {
        return (
            <PlayVideoButton
                buttonType={ButtonTypes.VodeItem}
                item={item}
                componentType={componentType}
                componentName={componentName}
                meta={meta}
                testId={isBookmared ? 'continue-watching-button' : 'play-now-button'}
            >
                {isBookmared && <>{__('continue_watching')} </>}
                {!isBookmared && <> {__('play_now')} </>}
            </PlayVideoButton>
        );
    }

    if (isTvod && (!isRented || (hours <= 0 && minutes <= 0))) {
        return (
            <PlayVideoButton
                buttonType={ButtonTypes.TVodItem}
                item={item}
                componentType={componentType}
                componentName={componentName}
                meta={meta}
                fromOverlay={true}
                onClick={() => {
                    if (item?.useCaseId) {
                        playerService.setUseCaseId(item?.useCaseId);
                    }
                    openDetailOverlay(item);
                }}
                testId="rent-button"
            >
                <span dangerouslySetInnerHTML={{ __html: tvodRentText }}></span>
            </PlayVideoButton>
        );
    }
};
